export default __webpack_public_path__ + "static/media/img-cursos.2e544419.jpg";